$(document).ready(function () {
    var parentClass = 'mobile-select';
    var activeClass = 'active';
    var hideClass = 'hide';
    var boxClass = 'mobile-select-box';
    var optionsClass = 'mobile-select-options';
    var allClass = "all-categories";
    var fadeSpeed = "fast"

    //TABELEMENT
    $(document).on('click', '.tab .tab-headers .tab-header', function () {
        var $this = $(this);
        if (!$this.hasClass('active')) {
            $this.addClass('active').siblings().removeClass('active');
            $this.parents('.tab').find('.tab-body').removeClass(activeClass).eq($this.index()).addClass(activeClass);
            reselect($this);
        }
    });

    //FILTER GRID ELEMENT
    $(".gridelement-filter .filter .category").on("click", function () {

        var $this = $(this);
        if ($this.hasClass(activeClass)) {
            if($this.data("uid") != "all") {
                if(!$this.siblings().hasClass(activeClass)) {
                    !$this.siblings("."+allClass).addClass(activeClass);
                }
                $this.removeClass(activeClass);
                toggleFilterElements($this)
                reselect($this)

            }
        } else {
            if($this.data("uid") == "all") {
                $this.addClass(activeClass).siblings().removeClass(activeClass);
            } else {
                $this.siblings().removeClass(activeClass);
                //$this.siblings("."+allClass).removeClass(activeClass);
            }
            $this.addClass(activeClass)
            toggleFilterElements($this)
            reselect($this)
        }
    });

    function toggleFilterElements($this) {
        var active = $this.parent().find('.active');
        var members = $this.parents(".gridelement-filter").children(".members");

        if($(active[0]).hasClass(allClass)) {
            members.find(".member").fadeIn(fadeSpeed)
            return;
        }

        var UIDs = [];
        active.each(function () {
            UIDs.push($(this).data("uid"));
        })

        members.find(".member").each(function () {
            var thisMember = $(this)
            var memberCategroies = thisMember.data('categories')
            var memberVisible = 0;

            $.each( UIDs, function( key, value ) {
                if(jQuery.inArray(value, memberCategroies) !== -1) {
                    memberVisible = 1
                }
            });

            if(memberVisible == 1) {
                thisMember.fadeIn(fadeSpeed);
            }else {
                thisMember.fadeOut(fadeSpeed);
            }
        })
    }

    //MOBILE SELECT
    $('.'+parentClass+ ' .'+boxClass).on('click', function () {
        var $this = $(this);
        $this.parents('.'+parentClass).toggleClass(activeClass);
        $this.siblings('.'+optionsClass).slideToggle(300);
    })

    function reselect($this) {
        var parent = $this.parent();

        var allObj = parent.children();
        var activeObj = parent.children('.'+activeClass);

        if ($(window).width() < 768) {
            parent.slideToggle(300, function () {
                allObj.removeClass(hideClass);
                activeObj.addClass(hideClass);
            });
        }else {
            allObj.removeClass(hideClass);
            activeObj.addClass(hideClass);
        }


        var activeString = "";
        activeObj.each(function () {
            if(activeString == "") {
                activeString = $(this).html();
            }else {
                activeString += ", " + $(this).html();
            }

        })
        parent.siblings('.'+boxClass).children('h5').html(activeString)
        parent.parents('.'+parentClass).removeClass(activeClass)
    }

});